//valid testuser actions


export const FETCH_TEST_USERS = "FETCH_TEST_USERS"
export const CREATE_TEST_USER = "CREATE_TEST_USER"
export const UPDATE_TEST_USER = "UPDATE_TEST_USER"
export const DELETE_TEST_USER = "DELETE_TEST_USER"

export const SHOW_CREATE_DIALOG = "SHOW_CREATE_DIALOG"
export const HIDE_CREATE_DIALOG = "HIDE_CREATE_DIALOG"
export const UPDATE_MESSAGE = "UPDATE_MESSAGE"
// export const SHOW_TEST_USER_DETAILS = "SHOW_TEST_USER_DETAILS"